module.exports = __webpack_public_path__ + "media/customizations/regencyatmilestoneranch/logo-c7eb31e9a0b640888c115afacdba3f15.png";